import axios from 'axios';

export function rejectServiceProvider(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/reject`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
        },
        withCredentials: true,
    })
        .then((response) => response.data)
        .catch((response) => response.response.data);
}

export function approveServiceProvider(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/provider/${data._id}/approve`,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
        },
        withCredentials: true,
    })
        .then((response) => response.data)
        .catch((response) => response.response.data);
}
export function getServiceProvidersHistory(portId, data) {
    return axios({
        method: 'POST',
        url: `/api/v2/ports/${portId}/service-providers/history`,
        data,
        withCredentials: true,
    })
        .then((response) => {
            response.data.total = response.headers['x-total-count'];
            return response.data;
        })
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/regions/serviceProvider.js